<template>
  <el-dialog
    title="赔偿金额"
    :visible="visible"
    width="560px"
    append-to-body
    @close="close"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="实际赔偿金额" prop="paid_amount"
        ><el-input-number
          v-model="form.paid_amount"
          :min="0"
          :precision="2"
          :controls="false"
          style="width: 260px"
        /><span class="unit">元</span></el-form-item
      >
      <el-form-item label="付款日期" prop="paid_date"
        ><el-date-picker
          v-model="form.paid_date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择付款日期"
      /></el-form-item>
      <el-form-item label="付款凭证">
        <el-upload
          action=""
          :show-file-list="false"
          :http-request="upload"
          accept=".pdf,.jpg,.png,.jpeg"
          ><el-button type="primary" size="small" :loading="uploading"
            >上传付款凭证</el-button
          ></el-upload
        >
        <div>
          <el-tag
            v-for="(url, index) in form.pay_urls"
            :key="`${url}-${index}`"
            closable
            class="file-tag"
            @close="form.pay_urls.splice(index, 1)"
            ><a :href="url" target="_blank">凭证 {{ index + 1 }}</a></el-tag
          >
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer"
      ><el-button @click="close">取消</el-button
      ><el-button type="primary" :loading="saving" @click="save"
        >保存</el-button
      ></span
    >
  </el-dialog>
</template>

<script>
import {
  getClaimInfo,
  updateCargoAmount,
  uploadClaimFile
} from "@/api/claims-management";
import {
  RISK_KEYS,
  formatDate,
  fromCents,
  toCents,
  toTimestamp
} from "../constants";

export default {
  name: "CompensationDialog",
  props: { visible: Boolean, orderId: [String, Number], riskType: Number },
  data() {
    return {
      saving: false,
      uploading: false,
      form: { paid_amount: 0, paid_date: "", pay_urls: [] },
      rules: {
        paid_amount: [
          { required: true, message: "请输入实际赔偿金额", trigger: "blur" }
        ],
        paid_date: [
          { required: true, message: "请选择付款日期", trigger: "change" }
        ]
      }
    };
  },
  watch: {
    visible(value) {
      if (value) this.load();
    }
  },
  methods: {
    async load() {
      const res = await getClaimInfo(RISK_KEYS[this.riskType], {
        id: Number(this.orderId)
      });
      const data = res.data || {};
      let payUrls = [];
      if (Array.isArray(data.pay_url)) payUrls = data.pay_url;
      else if (data.pay_url) {
        try {
          payUrls = JSON.parse(data.pay_url);
        } catch (error) {
          payUrls = String(data.pay_url).split(",");
        }
      }
      this.form = {
        paid_amount: Number(fromCents(data.paid_amount) || 0),
        paid_date:
          formatDate(data.paid_date) === "-" ? "" : formatDate(data.paid_date),
        pay_urls: payUrls
      };
    },
    async upload(options) {
      this.uploading = true;
      try {
        const formData = new FormData();
        formData.append("fileVal", options.file);
        const res = await uploadClaimFile(formData);
        this.form.pay_urls.push(res.data);
        options.onSuccess(res);
      } catch (error) {
        options.onError(error);
      } finally {
        this.uploading = false;
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          await updateCargoAmount({
            id: Number(this.orderId),
            paid_amount: toCents(this.form.paid_amount),
            paid_date: toTimestamp(this.form.paid_date),
            pay_url: this.form.pay_urls
          });
          this.$message.success("保存成功");
          this.$emit("changed");
          this.close();
        } finally {
          this.saving = false;
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
.unit {
  margin-left: 8px;
  color: #909399;
}
.file-tag {
  margin: 8px 8px 0 0;
}
.file-tag a {
  color: #409eff;
  text-decoration: none;
}
</style>
